/**
 * Created by smizrahi on 7/27/16.
 */

// Class
import ConfigGps from './ConfigGps'
import ConfigStepPause from './ConfigStepPause'
import ConfigStepMscore from './ConfigStepMscore'

// Const
import * as StepPause from './ConfigStepPause'
import * as StepMscore from './ConfigStepMscore'

export default class ConfigScenario {
    constructor(steps, gpsConfig, chainedTestId, label, iterations) {
        this.steps = steps;
        this.gpsConfig = gpsConfig;
        this.chainedTestId = parseInt(chainedTestId);
        this.iterations = parseInt(iterations);
        this.label = label;
        Object.freeze(this);
    }

    static restore(obj) {
        let steps = new Array();
        obj.steps.forEach(function (s) {
            if (s.type == StepPause.STEP_PAUSE_TYPE) steps.push(ConfigStepPause.restore(s));
            if (s.type == StepMscore.STEP_MSCORE_TYPE) steps.push(ConfigStepMscore.restore(s));
        });

        return new ConfigScenario(
            steps,
            ConfigGps.restore(obj.gpsConfig),
            obj.chainedTestId,
            obj.label,
            obj.iterations
        );
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/config/ConfigScenario.js